
import { useParams } from 'react-router-dom';
import { SucursalesFormState } from '../../../context/sucursales/SucursalesFormState';
import { Form } from './form';

export const SucursalesFormPage = () => {
  const { id } = useParams();
  const title = id ? "Editar Sucursal":"Crear Sucursal";

  return (
    <SucursalesFormState>
        <br />
        <Form title={title} />
    </SucursalesFormState>
  );
};
